var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { attrs: { isShowSearch: false }, on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-6M",
                    defaultEnd: "6M",
                    label: "작업기간",
                    name: "permitDates",
                  },
                  model: {
                    value: _vm.searchParam.permitDates,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "permitDates", $$v)
                    },
                    expression: "searchParam.permitDates",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    codeGroupCd: "SOP_SUPPLEMENT_WORK_TYPE_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "supplementWorkTypeCd",
                    label: "보충작업",
                  },
                  model: {
                    value: _vm.searchParam.supplementWorkTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "supplementWorkTypeCd", $$v)
                    },
                    expression: "searchParam.supplementWorkTypeCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "swpTable",
          attrs: {
            title: "작업허가서 목록",
            tableId: "swp01",
            columns: _vm.grid.columns,
            filtering: false,
            columnSetting: false,
            isFullScreen: false,
            data: _vm.grid.data,
            merge: _vm.grid.merge,
            gridHeight: "640px",
            rowKey: "sopWorkPermitId",
            selection: _vm.popupParam.type,
          },
          on: { linkClick: _vm.linkClick, rowDblclick: _vm.rowDblclick },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "검색", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                  _c("c-btn", {
                    attrs: { label: "선택", icon: "check" },
                    on: { btnClicked: _vm.select },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }